export const UNSTYLED = 'unstyled';
export const DEFAULT = 'default';